import { render, staticRenderFns } from "./withdraw.vue?vue&type=template&id=58128617&scoped=true&"
import script from "./withdraw.vue?vue&type=script&lang=js&"
export * from "./withdraw.vue?vue&type=script&lang=js&"
import style0 from "./withdraw.vue?vue&type=style&index=0&id=58128617&prod&scoped=true&lang=css&"
import style1 from "./withdraw.vue?vue&type=style&index=1&id=58128617&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58128617",
  null
  
)

export default component.exports